import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'

type HelloKittyBowLogoProps = {
  className?: string
}

/**
 * Logo nơ Hello Kitty (ảnh đã xoay sẵn, crop sát hình).
 * Khung: mobile 92x68, desktop 116x93 — logo contain + căn trái, không méo tỉ lệ.
 */
export const HelloKittyBowLogo = ({ className }: HelloKittyBowLogoProps) => (
  <div
    className={cn(
      'pointer-events-none relative h-[68px] w-[92px] shrink-0 lg:h-[93px] lg:w-[116px]',
      className
    )}
  >
    <Image
      src={ImageHelper.getImageUrlCdn('/image/2026/10/06/hk_logo_bow.png')}
      alt='Hello Kitty'
      fill
      sizes='116px'
      className='object-contain object-left'
    />
  </div>
)
